// extracted by mini-css-extract-plugin
module.exports = {"gameInfoModule":"CBGameInfoModule_gameInfoModule__2hLl4","gameInfoPadding":"CBGameInfoModule_gameInfoPadding__yXR-J"};